import { RevisionDeletedFragment } from 'gqlTypes'
import React from 'react'
import VersionItem from 'components/VersionItem/VersionItem'

export interface ActivityRevisionDeletedProps {
  revision: RevisionDeletedFragment
}

export const ActivityRevisionDeleted = ({
  revision,
}: ActivityRevisionDeletedProps) => {
  const { createdAtNN: createdAt, creatorNN: creator, userIsCreator } = revision

  return (
    <VersionItem
      type="deleted"
      creator={creator.name!}
      date={new Date(createdAt)}
      userIsCreator={userIsCreator}
      kind={'DRAFT'}
    />
  )
}
